import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'SubcontractorVendor' })
export class SubcontractorVendor {
  @Key id?: number;
  vendor: string;
  vendorName?: string;
  categories: number[];
}
